<template>
	<NewsPage
		:newsHeaderTitle="newsHeaderTitle"
		:newsItems="newsItems"
	/>
</template>
<script>
import moment from 'moment';
import NewsPage from './newsPage.vue';
export default {
	name: "newsArchives",
	components: {
		NewsPage,
	},
	props: {
		query: String,
		newsPage: String,
	},
	data() {
		return {
			newsHeaderTitle: "Cyber Corner News Archives",
			newsItems: [],
		};
	},
	mounted() {
		this.getNewsPosts();
	},
	methods: {
		getNewsPosts() {
			const _newsItems = this.$store.state.newsItems;
			const today = moment().valueOf();
			const fromTheLastSixMonths = moment().subtract(6, 'months').valueOf();
			// THIS RETRIEVES THE NEWS OLDER THAN THE LAST SIX MONTHS
			this.newsItems = _newsItems.filter(({ date }) => moment(date).valueOf() < fromTheLastSixMonths);
		},
	},
};
</script>